import { poseFilterEnergy } from '../../model/FragmentSearchResult';

/** Default bounds for the fragment energy-filter slider (binding free energies are <= 0). */
export const EnergyFilterLimits = {
    min: -10,
    max: 0,
};

/**
 * Lower bound for a fragment's energy-filter slider, derived from its loaded poses so the slider
 * spans the actual data instead of a fixed floor. Uses the same metric as the filter itself
 * (poseFilterEnergy — exchemP when valid, else interaction energy), which is why the bound often
 * needs to drop below the default -10 for gen2 fragments. The current filter value is included so
 * an existing setting stays reachable, and we floor to the slider step so the most extreme pose is
 * selectable. The default min is never raised, and we fall back to it when no finite pose energy
 * is loaded.
 * @param {import('BMapsModel').FragInfo} fragmentInfo
 * @param {number|null} filterValue current filter threshold for this fragment
 * @returns {number}
 */
export function fragmentEnergyFilterMin(fragmentInfo, filterValue) {
    const candidates = (fragmentInfo?.fragmentObjects ?? [])
        .map((pose) => poseFilterEnergy(pose))
        .concat(filterValue)
        .filter((e) => Number.isFinite(e));
    if (candidates.length === 0) return EnergyFilterLimits.min;
    // reduce rather than Math.min(...spread) to stay safe for large pose counts.
    const dataMin = candidates.reduce((lo, e) => (e < lo ? e : lo), Infinity);
    return Math.min(EnergyFilterLimits.min, Math.floor(dataMin * 2) / 2);
}
